export enum loadingStatuses {
  idle = "idle",
  pending = "pending",
  succeeded = "succeeded",
  failed = "failed",
}
